import { useMutation, useQueryClient } from 'react-query';
import Modal from '../../../../../../commons/Modal/Modal';
import Button from '../../../../../../designSystem/Button/Button';
import {
  DuplicateConsultationModalProps,
  DuplicateConsultationQuery,
} from './DuplicateConsultationModal.types';
import { useNavigate } from 'react-router-dom';
import {
  DUPLICATE_CONSULTATION_QUERY_KEY,
  duplicateConsultationQuery,
} from './DuplicateConsultationModal.query';
import { ButtonColor } from '../../../../../../designSystem/Button/Button.types';

export default ({ consultationId, isCompany, ...props }: DuplicateConsultationModalProps) => {
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { mutate } = useMutation<
    Awaited<ReturnType<typeof duplicateConsultationQuery>>,
    Error,
    DuplicateConsultationQuery
  >(({ consultationId }) => duplicateConsultationQuery({ consultationId }), {
    mutationKey: DUPLICATE_CONSULTATION_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: ({ consultationId }) => {
      navigate(`/dashboard/nouvelle_consultation/${consultationId}?duplicate=true`);
    },
    onError: (error) => {
      alert(error.message);
    },
  });

  return (
    <Modal style={{ height: 'fit-content' }} {...props}>
      <p>Êtes-vous sûr de vouloir dupliquer cette consultation ?</p>
      <Button
        style={{
          alignSelf: 'unset',
          textAlign: 'center',
          // borderRadius: 6,
          marginBottom: 'var(--spacing-s)',
          width: '60%',
          paddingLeft: 0,
          paddingRight: 0,
        }}
        color={isCompany ? ButtonColor.Secondary : ButtonColor.Primary}
        onClick={() => mutate({ consultationId })}>
        Oui
      </Button>
      <Button
        style={{
          alignSelf: 'unset',
          textAlign: 'center',
          // borderRadius: 6,
          marginBottom: 'var(--spacing-s)',
          width: '60%',
          paddingLeft: 0,
          paddingRight: 0,
        }}
        color={isCompany ? ButtonColor.Secondary : ButtonColor.Primary}
        onClick={() => props.setOpen(false)}>
        Non
      </Button>
    </Modal>
  );
};
